module.exports = __webpack_public_path__ + "img/fox.9e44dedc.jpg";